import { render, staticRenderFns } from "./groceryBagLandingPage.vue?vue&type=template&id=9486f762&"
import script from "./groceryBagLandingPage.vue?vue&type=script&lang=js&"
export * from "./groceryBagLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./groceryBagLandingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports